import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { Result, Button, Typography } from 'antd';
const { Paragraph, Text } = Typography;
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleReset = () => {
            this.setState({ hasError: false, error: undefined, errorInfo: undefined });
        };
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        this.setState({
            error,
            errorInfo,
        });
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsx(Result, { status: "error", title: "Algo sali\u00F3 mal", subTitle: "Ha ocurrido un error inesperado. Por favor, intenta nuevamente.", extra: [
                    _jsx(Button, { type: "primary", onClick: this.handleReset, children: "Intentar nuevamente" }, "retry"),
                    _jsx(Button, { onClick: () => window.location.reload(), children: "Recargar p\u00E1gina" }, "reload"),
                ], children: process.env.NODE_ENV === 'development' && this.state.error && (_jsxs("div", { style: { textAlign: 'left', marginTop: 16 }, children: [_jsx(Paragraph, { children: _jsx(Text, { strong: true, children: "Error Details (Development Mode):" }) }), _jsx(Paragraph, { children: _jsx(Text, { code: true, children: this.state.error.toString() }) }), this.state.errorInfo && (_jsx(Paragraph, { children: _jsx(Text, { code: true, style: { whiteSpace: 'pre-wrap' }, children: this.state.errorInfo.componentStack }) }))] })) }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
